import { TaxonomyLensData } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { useCarouselContext } from '../../../impact-lens-profile/context';

export function useTaxonomyLensContext() {
  const context = useCarouselContext();
  if (context.lensType === ImpactLensType.EU_TAXONOMY) {
    return { data: context.data as TaxonomyLensData };
  }
  return undefined;
}
